import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import WaterUseTypeForm from '../Forms/WaterUseTypeForm';

const AddEditWaterUseTypeModal = ({
	dataWaterUseType,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Tipo de Uso de Agua
			</ModalHeader>

			<WaterUseTypeForm
				dataWaterUseType={dataWaterUseType}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditWaterUseTypeModal;
